module.exports = __webpack_public_path__ + "img/lishishuju2.0ce6e40a.png";